import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { HeaderLink, HeaderWrapper, Logo, NavLinks } from "./__style";
import endpoints from "../../../services/endpoints";
import { isAuthenticated } from "../../../utils/helpers/functions";
import { AccountCircle } from "@mui/icons-material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/slices/user-slice";
var Header = function (_a) {
    var layoutType = _a.layoutType;
    var auth_status = isAuthenticated();
    var _b = useState(false), drawerOpen = _b[0], setDrawerOpen = _b[1];
    var userMetadata = useSelector(selectUser.userMetaData);
    var toggleDrawer = function (open) { return function () {
        setDrawerOpen(open);
    }; };
    return (_jsxs(HeaderWrapper, { children: [_jsx(Logo, { children: _jsx(Link, { to: endpoints.web.home, children: "CorpTrip" }) }), _jsxs(NavLinks, { children: [auth_status && (_jsx(_Fragment, { children: _jsx(HeaderLink, { children: _jsx(Link, { to: "".concat(endpoints.web.profile, "/").concat(userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.username), children: _jsx(AccountCircle, {}) }) }) })), !auth_status && (_jsx(HeaderLink, { children: _jsx(Link, { to: endpoints.web.login, children: "Log in" }) }))] })] }));
};
export default Header;
